export default {
    // 모달/레이어 관련
    modal: {
        logout: {
            title: '로그아웃',
            message: '로그아웃 할까요?',
        },
        confirm: {
            title: '확인',
            message: '정말로 진행하시겠습니까?',
        },
    },

    // 드롭다운/셀렉트 관련
    dropdown: {
        selectOption: '옵션을 선택하세요',
        noOptions: '선택할 수 있는 옵션이 없습니다',
    },

    // 테이블 관련
    table: {
        headers: {
            item: '항목',
            content: '내용',
            activity: '활동',
            mode: '모드',
            result: '결과',
            time: '시간',
            student: '학생',
            answer: '답변',
            score: '점수',
            status: '상태',
        },
        noData: '데이터가 없습니다',
        loading: '로딩 중...',
    },

    // 폼 관련
    form: {
        required: '필수 입력 항목입니다',
        invalid: '올바르지 않은 형식입니다',
        saved: '저장되었습니다',
        errors: {
            network: '네트워크 오류가 발생했습니다',
            validation: '입력 정보를 다시 확인해주세요',
            server: '서버 오류가 발생했습니다',
        },
    },

    // 로딩/상태 관련
    loading: {
        default: '로딩 중...',
        saving: '저장 중...',
        processing: '처리 중...',
        connecting: '연결 중...',
    },

    // 알림/토스트 관련
    toast: {
        success: '성공적으로 완료되었습니다',
        error: '오류가 발생했습니다',
        warning: '주의가 필요합니다',
        info: '정보를 확인해주세요',
    },
};
